import { createVanIconComponent } from "./van"

const Question = createVanIconComponent("question")
export default Question
